import { graphql } from "../gql";

export const publishAuditRuleMutationDoc = graphql(`
  mutation PublishAuditRule($input: PublishAuditRuleInput!) {
    publishAuditRule(input: $input) {
      ruleId
      status
      suggestionsRequested
    }
  }
`);
